import {
    Container,
    Content,
    AccessLevelInfo
} from './styled';
import { Avatar } from '../../../../../components';
import {
    FaIdCardAlt
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import {
    IoSettingsSharp
} from "react-icons/io5";

export function CardUser({ user, onClick }) {
    const {
        nomecompleto,
        nomeusuario,
        access_level,
        ativo,
        email
    } = user;

    return (
        <Container statusUser={ativo}>
            <Avatar
                className="userAvt"
                name={nomecompleto}
                width={'3rem'}
                height={'3rem'}
                borderRadius={'4px'}
            />
            <Content>
                <div>
                    <div>
                        <span className='title'>
                            {nomecompleto}
                        </span>
                        <span className='subtitle'>
                            <FaIdCardAlt />
                            {nomeusuario}
                        </span>
                        <span className='subtitle'>
                            <MdEmail />
                            {email}
                        </span>
                    </div>
                    <div>
                        <AccessLevelInfo>
                            {(access_level?.length > 0) &&
                                access_level?.map((access) => {
                                    if (!access?.abreviatura) return
                                    return (
                                        <li key={access?.name}>
                                            {access?.abreviatura}
                                        </li>
                                    )
                                })
                            }
                        </AccessLevelInfo>
                    </div>
                </div>
                <div onClick={onClick}>
                    <span>
                        <IoSettingsSharp
                            className='user-settings'
                        />
                    </span>
                </div>
            </Content>
        </Container>
    )
}